// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GL_k","question":"styles_question__2_VUr","description":"styles_description__1tzVx"};